import React from 'react';
import PropTypes from 'prop-types';
import Button from '@concur/nui-widgets/lib/Buttons/Button';
import { withThemeStyles } from '@concur/ui-theming';
import classnamesBind from 'classnames/bind';
import withNuiFormatter from '../utils/withNuiFormatter';
import withErrorBoundary from '../utils/withErrorBoundary';
import compose from '../utils/compose';
import * as styles from './AppMiniHeader-*.css';

const CSS_BLOCK = 'sapcnqr-app-mini-header';

const MiniHeader = ({
    classNameMap,
    formatter,
    isGov,
    isLoggedIn,
    logoutUser,
}) => {
    const classnames = classnamesBind.bind(classNameMap);

    const baseClasses = classnames(CSS_BLOCK);

    const homeIconClasses = classnames(
        `${CSS_BLOCK}__home-icon`,
        {
            [`${CSS_BLOCK}__home-icon--gov`]: isGov,
        },
    );

    return (
        <div className={baseClasses}>
            <span>
                <i
                    aria-label="SAP Concur"
                    className={homeIconClasses}
                    id="app-mini-header-logo"
                    role="img"
                />
            </span>
            {isLoggedIn && (
                <Button
                    data-test="app-mini-header-signout-link"
                    onClick={logoutUser}
                    type="link"
                    className={classnames(`${CSS_BLOCK}__button--signout`)}
                >
                    {formatter.formattedMessage({ id: 'CoreUI.signOut' })}
                </Button>
            )}
        </div>
    );
};

MiniHeader.displayName = 'MiniHeader';

MiniHeader.cssBlock = CSS_BLOCK;

MiniHeader.propTypes = {
    isLoggedIn: PropTypes.bool,
    isGov: PropTypes.bool,
    logoutUser: PropTypes.func,
};

export default withThemeStyles(compose(
    withNuiFormatter,
    withErrorBoundary,
)(MiniHeader), styles);
